/* eslint-disable no-param-reassign */
// eslint-disable-next-line
export default function (_window, _document, loaderURL, payloadURL, trackingURL, placementId, adId, image, thirdPartyImpression, ascm, macros, organisationLineItemID, organisationInventoryID, organisationAudienceId, organisationAudienceSegmentId, organisationAudienceCustom) {
  const AD_EVENT = 'evt';
  const AD_PLACEMENT_ID = 'pid';
  const AD_ID = 'aid';
  const SESSION_UUID = 'sid';
  const SESSION_TIME = 'sst';
  const AD_TIME_ISO = 'ti';
  const AD_TIME_OFFSET = 'to';
  const TAG_SELECTOR_PREFIX = 'ivo';
  const COMPONENT_SELECTOR_PREFIX = 'i';
  const WINDOW_GLOBAL_NAMESPACE_PREFIX = 'ivo_ad_';
  const ORGANISATION_LINE_ITEM_ID = 'tpl';
  const ORGANISATION_INVENTORY_ID = 'tpi';
  const ORGANISATION_AUDIENCE_ID = 'tpid';
  const ORGANISATION_AUDIENCE_SEGMENT_ID = 'tpsid';
  const ORGANISATION_AUDIENCE_CUSTOM = 'tpc';

  const time = new Date();
  const sessionId = (() => {
    let sessionTime = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = ((sessionTime + Math.random()) * 16) % 16 | 0; // eslint-disable-line no-bitwise
      sessionTime = Math.floor(sessionTime / 16);
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16); // eslint-disable-line no-bitwise
    });
  })();
  const escapedParam = (param => escape(param));

  const element = _document.getElementById(`${TAG_SELECTOR_PREFIX}-${placementId}`);
  element.id = `${COMPONENT_SELECTOR_PREFIX}-${placementId}`;
  element.classList.add(`${COMPONENT_SELECTOR_PREFIX}-${placementId}`);

  // eslint-disable-next-line
  const impressionPixel = `${trackingURL}?${AD_EVENT}=impression&${AD_PLACEMENT_ID}=${placementId}&${AD_ID}=${adId}&${SESSION_TIME}=0&${SESSION_UUID}=${sessionId}&${ORGANISATION_LINE_ITEM_ID}=${escapedParam(organisationLineItemID)}&${ORGANISATION_INVENTORY_ID}=${escapedParam(organisationInventoryID)}&${ORGANISATION_AUDIENCE_ID}=${escapedParam(organisationAudienceId)}&${ORGANISATION_AUDIENCE_SEGMENT_ID}=${escapedParam(organisationAudienceSegmentId)}&${ORGANISATION_AUDIENCE_CUSTOM}=${escapedParam(organisationAudienceCustom)}&${AD_TIME_ISO}=${time.toISOString()}${AD_TIME_OFFSET}=${time.getTimezoneOffset()}`;

  const impressionTracking = thirdPartyImpression.concat(impressionPixel);

  // Fires the impression
  impressionTracking.forEach(url => image.setAttribute('src', url));

  const organisationTracking = { organisationLineItemID, organisationInventoryID, organisationAudienceId, organisationAudienceSegmentId, organisationAudienceCustom };

  const adNameSpace = `${WINDOW_GLOBAL_NAMESPACE_PREFIX}${placementId}`;
  _window[adNameSpace] = [];
  _window[adNameSpace].push({ sessionId, element, ascm, macros, organisationTracking, rendered: false });

  const script = 'script';
  const head = _document.head || _document.getElementsByTagName('head')[0];
  const cachebuster = `?${(new Date()).getTime()}`;

  if (loaderURL !== '') {
    // Create a new script element
    const loaderScriptElement = _document.createElement(script);
    // The new script should load asynchronously
    loaderScriptElement.async = 1;
    // Load Init
    loaderScriptElement.src = `${loaderURL}${cachebuster}`;
    // Add to head
    head.appendChild(loaderScriptElement);
  }
  // Create a new script element
  const payloadScriptElement = _document.createElement(script);
  // The new script should load asynchronously
  payloadScriptElement.async = 1;
  // Load Init
  payloadScriptElement.src = `${payloadURL}${cachebuster}`;
  // Add to head
  head.appendChild(payloadScriptElement);
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/components/HTMLTag/tag.js